import {
  ClockCircleOutlined,
  EyeOutlined,
  FileOutlined,
} from '@ant-design/icons';
import { AccordionItem } from '@mm/components';
import { ArrowUpDownIcon } from '@mm/icons/general/ArrowUpDownIcon';
import { ClickIcon } from '@mm/icons/general/ClickIcon';
import { SpeedometerIcon } from '@mm/icons/general/SpeedometerIcon';
import { ContactLeadScoring } from '@mm/state/interfaces/contacts';
import classNames from 'classnames';
import moment from 'moment';
import React from 'react';
import styles from './LeadScoring.module.css';

type Props = {
  leadScoring?: ContactLeadScoring;
  className?: string;
};

const LeadScoringContent = (props: { leadScoring: ContactLeadScoring }) => {
  const { leadScoring } = props;
  const duration = moment.duration(leadScoring.time);
  const hours = Math.floor(duration.asHours());
  return (
    <>
      <div className={styles.dataRow}>
        <ClockCircleOutlined />
        <div>Time on site</div>
        <div>
          {hours ? `${hours}:` : ''}
          {moment.utc(duration.asMilliseconds()).format('mm:ss')}
        </div>
      </div>
      <div className={styles.dataRow}>
        <EyeOutlined />
        <div>Total Visits</div>
        <div>{leadScoring.sessions}</div>
      </div>

      <div className={styles.dataRow}>
        <FileOutlined />
        <div>Page Views</div>
        <div>{leadScoring.views}</div>
      </div>
      <div className={styles.dataRow}>
        <ArrowUpDownIcon className={styles.dataRowIcon} />
        <div>Scroll depth</div>
        <div>{Math.floor(leadScoring.scroll / 96)} inches</div>
      </div>
      <div className={styles.dataRow}>
        <ClickIcon className={styles.dataRowIcon} />
        <div>Clicks</div>
        <div>{leadScoring.clicks}</div>
      </div>
    </>
  );
};

export const LeadScoring = ({ leadScoring, className }: Props) => {
  if (!Object.values(leadScoring || {}).filter(Boolean).length) {
    return null;
  }
  return (
    <div className={classNames(styles.wrapper, className)}>
      <AccordionItem
        icon={<SpeedometerIcon className={styles.accordionIcon} />}
        title="Customers.ai Lead Scoring"
        closeOnOutsideClick={false}
        className={styles.accordionItem}
        headingClassName={classNames(
          'contact-details__accordion-item-heading',
          'contact-details__accordion-item-heading-major',
        )}
        showArrow={false}
        withBorder={false}
        canToggle={false}
        openOnMount
      >
        <div className={styles.content}>
          {leadScoring?.time && (
            <LeadScoringContent leadScoring={leadScoring} />
          )}
        </div>
      </AccordionItem>
    </div>
  );
};
